import { HStack, VStack } from '@montel/montelpro-shared-components-v2';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import { styled } from 'styled-components';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';
import BundledSubscriptionUsersTable from './BundledSubscriptionUsersTable';

const ExpandedContent = styled(VStack)`
	padding: ${({ theme }) => theme.spacing.lg};
`;

export const ExpandedBundledSubscriptionContent: React.FunctionComponent<{
	subscription: Subscription;
	productId: string;
	onUserUnassigned: () => void;
}> = ({ subscription, productId, onUserUnassigned }) => {
	const { getMinimalAreaRepresentation } = useGlobalContext();

	const appPermissions = subscription.applicationPermissions[productId];
	const hasAreas = appPermissions.countries?.length > 0;

	return (
		<ExpandedContent fullWidth gap="xxl">
			<HStack fullWidth gap="10xl">
				<LabelAndValue
					label="Description"
					value={subscription.description || '-'}
				/>
				{hasAreas && (
					<LabelAndValue
						label="Areas"
						value={getMinimalAreaRepresentation(
							productId,
							appPermissions.countries,
						)?.map((area) => (
							<span key={area?.code}>{area?.name}</span>
						))}
					/>
				)}
			</HStack>
			<HStack fullWidth>
				{subscription?.occupiedSeats > 0 && (
					<BundledSubscriptionUsersTable
						subscription={subscription}
						onUserUnassigned={onUserUnassigned}
					/>
				)}
			</HStack>
		</ExpandedContent>
	);
};
